 <!-- 我的收藏 -->
<template>
  <div class="enroll">
    <div class="head">
      <div class="head-left"> 
        <p class="title">我的收藏</p>
      </div>
    </div>

    <div class="enroll-list">
      <span class="certificate-obtained">收藏课程</span>
      <ul>
        <li v-for="item,index in collectionList" :key="index" @click="onExamDetails(item.id)">
          <div class="enroll-list-play">
            <img class="enroll-list-img" :src="item.courseImg">
            <img class="enroll-list-icon" src="../../assets/img/icon4.png">
          </div>
          <div class="enroll-list-content">
            <p class="enroll-list-name">{{item.courseName}}</p>
            <div class="enroll-list-intotal">
              <p class="enroll-list-intotal-period">共{{item.durationHour}}课时</p>
              <p class="enroll-list-intotal-number">{{item.learnCount}}人学习</p>
            </div>
            <div style="padding: 10px 0 0;display: flex;align-items: center;justify-content: space-between;">
              <!-- <p class="enroll-list-time" v-if="item.itemCount">已学{{item.learnedCount}}/{{item.itemCount}}课时</p> -->
              <div class="enroll-list-cancel" @click.stop="onCollect(item.id)">
                <img src="../../assets/img/icon5.png">
                <span>取消收藏</span>
              </div>
            </div>
          </div>
        </li>
        <!-- <li>
          <div class="enroll-list-play">
            <img class="enroll-list-img" src="../../assets/img/bg.png" alt="">
            <img class="enroll-list-icon" src="../../assets/img/icon4.png" alt="">
          </div>
          <div class="enroll-list-content">
            <p class="enroll-list-name">数据库名称数据库名称</p>
            <div class="enroll-list-intotal">
              <p class="enroll-list-intotal-period">共28课时</p>
              <p class="enroll-list-intotal-number">26359人学习</p>
            </div>
            <div style="padding: 10px 0 0;display: flex;align-items: center;justify-content: space-between;">
              <p class="enroll-list-time">已学3/28课时</p>
              <div class="enroll-list-cancel">
                <img src="../../assets/img/icon5.png" alt="">
                <span>取消收藏</span>
              </div>
            </div>
          </div>
        </li> -->
      </ul>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :current-page="page"
        :page-size="rows"
        @current-change="currentChange">
      </el-pagination>
    </div>
    
  </div>
</template>

<script>
import { myCollectionList,collectCourse } from '../../api/userMG'
export default {
  data() {
    return {
      collectionList:[],
      page:1,
      rows:16,
      total:0,
    }
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  created() {
    this.getMyCollectionList();
  },
  methods:{
     // 获取订单列表
     async getMyCollectionList(){
      let params = {
        page:this.page,
        rows:this.rows
      }
      await myCollectionList(params).then(res => {
        console.log('订单列表',res);
        this.collectionList = res.data.content;
        this.total = res.data.total;
      })
    },
    currentChange(e){
      console.log(e)
      this.page = e;
      this.getMyCollectionList()
    },
    // 收藏
    onCollect(id){
      collectCourse({courseId:id}).then(res => {
        console.log('收藏',res.data);
        if(res.code == 0){
          this.getMyCollectionList()
        }
      })
    },
    onExamDetails(id){
      this.$router.push({path:'/index/classroomDetails',query: { id: id, type:1 }})
    },
  }
}
</script>

<style scoped>
  .enroll{
    padding: 30px 20px 50px;
    background-image: linear-gradient(bottom,#fff,#fff8f2);
    border: 1px solid #e1e2e6;
    border-radius: 8px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
  }
  .head .title{
    font-size: 14px;
    font-weight: 500;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }
  
  .enroll-list{
    margin-bottom: 24px;
    padding: 26px 0 0;
  }
  .certificate-obtained{
    font-size: 14px;
    color: #f25902;
    padding: 10px 6px;
    border-bottom: 2px solid #f25902;
    margin: 0 4px;
  }
  .enroll-list ul{
    margin: 36px 0 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

  }
  .enroll-list ul li{
    width: 31%;
    margin-bottom: 20px;
    margin-right: 20px;
  }
  .enroll-list-play{
    position: relative;
    cursor: pointer;
  }
  .enroll-list-icon{
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 10px;
    height: 10px;
    padding: 10px;
    border-radius: 50%;
    background-color: rgba(6, 6, 6, 0.3);
  }
  .enroll-list-img{
    width: 100%;
    /* height: 138px; */
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  .enroll-list-content{
    border: 1px solid #eaebed;
    border-top: none;
    padding: 10px 12px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  .enroll-list-name{
    font-size: 14px;
    color: black;
    margin-bottom: 10px;
  }
  .enroll-list-intotal{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 10px;
  }
  .enroll-list-intotal-period{
    font-size: 12px;
    padding: 3px 10px;
    border-radius: 20px;
    background: #fcf2e8;
    color: #f16418;
    margin-right: 6px;
  }
  .enroll-list-intotal-number{
    font-size: 12px;
    padding: 2px 10px;
    border-radius: 20px;
    color: #f16418;
    border: 1px solid #fee5d9;
  }
  .enroll-list-time{
    font-size: 12px;
    color: #adadad;
  }
  .enroll-list-cancel{
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .enroll-list-cancel img{
    width: 12px;
    height: 12px;
    margin-right: 6px;
  }
  .enroll-list-cancel span{
    color: #f26f2b;
    font-size: 12px;
  }
  .pagination /deep/ .active{
    background: #ff821c !important;
  }
  .pagination /deep/ .number:hover{
    color: #ff821c !important;
  }
  
  
</style>


// WEBPACK FOOTER //
// src/views/collect/collect.vue